import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UtilService, ModalScroll, FormValidationsService, SERVICE_END_POINT, AnalyticsService, AuthService } from 'src/app/shared';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/state/app.state';
import { Subscription, Observable } from 'rxjs';
import * as UserDataConfig from '../../config/user-data.config';
import * as YourLumpSumAllowanceActions from '../../../../store/actions/your-lump-sum-allowances.actions';
import * as RefNoActions from '../../../../store/actions/reference-number.actions';
import { ApplicationDataCaptureService } from 'src/app/shared/services/api-services/application-datacapture.service';
import * as loggedInDetailActions from '../../../../store/actions/loggedin-detail.action';
import { ParentFormAndElmModel } from 'src/app/model/key-value-modal';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { YourLumpSumAllowances } from 'src/app/model/ngrx/your-lump-sum-allowances.model';

@Component({
  selector: 'your-lump-sum-allowances',
  templateUrl: './your-lump-sum-allowances.component.html',
  styleUrls: ['./your-lump-sum-allowances.component.scss']
})
export class YourLumpSumAllowancesComponent implements OnInit {
  userForm: UntypedFormGroup;
  yourLumpSumAllowanceForm: UntypedFormGroup;
  contentData;
  getQueryParameters;
  public userInputDetail = UserDataConfig.ElementsConfig;
  public nextButtonDisabled: boolean;
  public noSelectedFlag: boolean;
  yourLumpSumAllowancesStore: Observable<YourLumpSumAllowances[]>;
  yourLumpSumAllowances: YourLumpSumAllowances;
  
  private subscriptn: Subscription;
  private subscripBeforeLogin: Subscription;
  private subscripSaveProgress: Subscription;
  private subscripLogout: Subscription;
  responseApplicationData: any;
  protected resultQuote: {};
  protected CMSData;
  yourLumpSumAllowancesStoreSubscription: Subscription;
  screenName;
  isHOView = false;
  public protectionTypeConfig = this.userInputDetail.protectionTypeConfig;
  public lsaProtectionTypeConfig = this.userInputDetail.lsaProtectionTypeConfig;
  displayHigherAllowanceWarningMsg: boolean = false;
  displayProtectionTypeWarningMsg: boolean = false;
  constructor(private fb: UntypedFormBuilder, private router: Router,
              private activatedRoute: ActivatedRoute, private store: Store<AppState>,
              private authService: AuthService,
              private btnFocusOnModalClose: ModalScroll, public el: ElementRef,
              private utilService: UtilService,
              private applicationDatacaptureService: ApplicationDataCaptureService, private analyticsService: AnalyticsService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.yourLumpSumAllowances;
    this.yourLumpSumAllowancesStore = store.select(STORE_VAL.your_lump_sum_allowances);
    this.yourLumpSumAllowancesStoreSubscription = this.yourLumpSumAllowancesStore.subscribe((val) => {
      if (val && val.length > 0) {
        this.yourLumpSumAllowances = val[0];
         
      }
    });
    store.select(STORE_VAL.application_data_response).subscribe((val) => {
      if (val && val.length > 0) {
        this.responseApplicationData = val[0];
         
      }
    });
   
    this.activatedRoute.queryParams.subscribe(params => {
      this.getQueryParameters = params;
      
    });
  }

  ngOnInit() {
    this.GetCMSDataServiceMapper();
   // this.analyticsService.orderTrack({ internalReferenceDCJ: this.resposeJsonQuoteCaptureStore['quoteRefs'][0], applicationReferenceDCJ:this.resposeJsonQuoteCaptureStore['applicationId']});
  }

  userFormData = () => {
    this.userInputDetail.buttonConfig.label = 'Next';
    this.userForm = this.fb.group({
      next: ['']
    });
  } 
  setYourLumpSumAllownaces() {
    this.yourLumpSumAllowanceForm = this.fb.group({
      lsaQuestion: [null, Validators.required],
      lsDbaQuestion: [null, Validators.required],
      lsaLgaProtectionQuestion: [null],
      protectionType: [null]
    });
  }

  
  createQuestionarray(): any {
    const questionArray = [];
    if (this.yourLumpSumAllowanceForm.controls.lsaQuestion.value) {
      questionArray.push({
        questionCode: 'lsaQuestion',
        questionType: this.contentData.lsaQuestion.questionType,
        answer: this.yourLumpSumAllowanceForm.controls.lsaQuestion.value
      });
    }
    if (this.yourLumpSumAllowanceForm.controls.lsDbaQuestion.value) {
      questionArray.push({
        questionCode: 'lsDbaQuestion',
        questionType: this.contentData.lsDbaQuestion.questionType,
        answer: this.yourLumpSumAllowanceForm.controls.lsDbaQuestion.value
      });
    }
    if (this.yourLumpSumAllowanceForm.controls.lsaLgaProtectionQuestion.value) {
      questionArray.push({
        questionCode: 'lsaLgaProtectionQuestion',
        questionType: this.contentData.lsaLgaProtectionQuestion.questionType,
        answer: this.yourLumpSumAllowanceForm.controls.lsaLgaProtectionQuestion.value
      });
    }
     
    return questionArray;
  }
  goBack() {
    this.saveFormValues();
    this.applicationDatacaptureService.postApplicationDataCapture(true).subscribe(res => {
      this.router.navigate(['/apply/your-pension-savings']);
    });
   
  }
  gotoNext = () => {
    if (this.yourLumpSumAllowanceForm.valid) {
      this.saveFormValues();
      this.btnFocusOnModalClose.handleModalScrollFlag({ scrollModalFlag: false, btnFocus: false });
      this.applicationDatacaptureService.postApplicationDataCapture(true).subscribe(res => {
        if(res['showBeneficiary']) {
          this.router.navigate(['/apply/your-beneficiary-details']);
        } else {
          this.router.navigate(['/apply/your-payment-details']);
        }
       
      });
    } else {
      FormValidationsService.validateAllFormFields(this.yourLumpSumAllowanceForm, this.analyticsService);
      setTimeout(() => {
        this.scrollInvalidForm();
      });
    }
  }
  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }
  }
  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy() {
    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }

    if (this.yourLumpSumAllowancesStoreSubscription) {
      this.yourLumpSumAllowancesStoreSubscription.unsubscribe();
    }
    this.utilService.setParentFormToValidate(null);
  }
  saveFormValues() {
    this.store.dispatch(new YourLumpSumAllowanceActions.RemoveYourLumpSumAllowances(0));
    this.store.dispatch(new YourLumpSumAllowanceActions.AddYourLumpSumAllowances({
      lsaQuestion: this.yourLumpSumAllowanceForm.controls.lsaQuestion.value ? this.yourLumpSumAllowanceForm.controls.lsaQuestion.value : null,
      // tslint:disable-next-line:max-line-length
      lsDbaQuestion: this.yourLumpSumAllowanceForm.controls.lsDbaQuestion.value ? this.yourLumpSumAllowanceForm.controls.lsDbaQuestion.value : null,
      lsaLgaProtectionQuestion: this.yourLumpSumAllowanceForm.controls.lsaLgaProtectionQuestion.value ? this.yourLumpSumAllowanceForm.controls.lsaLgaProtectionQuestion.value : null,
      protectionType: this.yourLumpSumAllowanceForm.controls.protectionType.value ? this.yourLumpSumAllowanceForm.controls.protectionType.value : null,
      riskAndStaticQuestion: this.createQuestionarray(),
       
    }));
  }
  saveProgress() {
    this.saveFormValues();
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe();
  }
  saveAfterLogout() {
    this.saveFormValues();
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  dateFormat = (dateValue: string) => {
    return dateValue.indexOf('/') > -1 ? (dateValue.split('/').join(' / ')) : dateValue;
  }

    /** Code block for CMS */
    GetCMSDataServiceMapper() {
      const URL = SERVICE_END_POINT.higherEnvironment.CMS_YOUR_LUMP_SUM_ALLOWANCES;
      //console.log('changed value = ', );
      this.utilService.getCMSData(URL).subscribe(res => {
        //console.log('2 GetCMSDataService => ', res);
        this.CMSData = res;
        if (this.CMSData) {
          /** In the line below we are over-writing the contentData object values with CMSData object values */
          this.contentData.header = this.CMSData.string_YourLumpSumAllowancesTitle;
          this.contentData.string_YourLumpSumAllowances_paragraph1 = this.CMSData.string_YourLumpSumAllowances_paragraph1;
          this.contentData.string_YourLumpSumAllowances_paragraph2 = this.CMSData.string_YourLumpSumAllowances_paragraph2;
          this.contentData.string_YourLumpSumAllowances_paragraph3 = this.CMSData.string_YourLumpSumAllowances_paragraph3;

          this.contentData.lsaQuestion.questionStatement = this.CMSData.string_TaxFreeCashAllowanceQuestion;
          this.contentData.lsDbaQuestion.questionStatement = this.CMSData.string_HigherAllowanceQuestion;
          this.contentData.lsaLgaProtectionQuestion.questionStatement = this.CMSData.string_ProtectionInPlaceQuestion;
          this.contentData.string_HigherAllowanceWarningMessageWording = this.CMSData.string_HigherAllowanceWarningMessageWording;
          this.contentData.string_lsaRulesText = this.CMSData.string_UnderstandingTheRulesWording;
          this.contentData.protectionWarningMessage= this.CMSData.string_CopyOfCertificateWording;
          this.lsaProtectionTypeConfig.label = this.CMSData.string_WhatProtectionHaveYouBeenGivenQuestion;
          this.screenDataBinding();
        }
      });
    }
    /** End of code block for CMS */
    /** For web tracking */
    getCurrentScreenURL() {
      this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
      return this.screenName;
    }
    lsaReceiver(val) {
      this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
    }
    lsaDbaReceiver(val) {
      this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
    }
    lsaLgaProtectionReceiver(val) {
      this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
    }
   
  ddlChange(event: any) {
    this.displayProtectionTypeWarningMsg = this.yourLumpSumAllowanceForm.get('protectionType').value ? true : false;
    const code = this.yourLumpSumAllowanceForm.get('protectionType').value;
    const value = (this.lsaProtectionTypeConfig.options.find(obj => obj.code === code)).value;
    this.analyticsService.eventTrack({ type: 'Dropdown', name: this.lsaProtectionTypeConfig.label, pageID: this.getCurrentScreenURL(), details: value });
  }
  toggleChangeTFCAllowance(data, ctrlName) {
    this.analyticsService.errorAnalyticsTrack({ formErrorMessage: '', formErrorType: '', formErrorDetail: '', formErrorCount: 0}) 
    switch (ctrlName) {
      case 'lsaQuestion':
        if (data === 'Y' || this.yourLumpSumAllowanceForm.get('lsDbaQuestion').value === 'Y') {
          this.yourLumpSumAllowanceForm.controls['lsaLgaProtectionQuestion'].setValidators([Validators.required]);
        } else {
          this.yourLumpSumAllowanceForm.controls['lsaLgaProtectionQuestion'].clearValidators();
          this.yourLumpSumAllowanceForm.controls['lsaLgaProtectionQuestion'].setValue(null);          
        }
        break;
      case 'lsDbaQuestion':
        if (data === 'Y' || this.yourLumpSumAllowanceForm.get('lsaQuestion').value === 'Y') {
          this.yourLumpSumAllowanceForm.controls['lsaLgaProtectionQuestion'].setValidators([Validators.required]);
        } else {
          this.yourLumpSumAllowanceForm.controls['lsaLgaProtectionQuestion'].clearValidators();
          this.yourLumpSumAllowanceForm.controls['lsaLgaProtectionQuestion'].setValue(null);          
        }
        break;
      case 'lsaLgaProtectionQuestion':
        if (data === 'Y') {
          this.displayHigherAllowanceWarningMsg = false;
          this.yourLumpSumAllowanceForm.controls['protectionType'].setValidators([Validators.required]);          
        } else {
          this.displayProtectionTypeWarningMsg = false;
          this.yourLumpSumAllowanceForm.controls['protectionType'].clearValidators();
          this.yourLumpSumAllowanceForm.controls['protectionType'].setValue(null);  
           this.displayHigherAllowanceWarningMsg = this.responseApplicationData['businessType'] == 'IVPP' ? true : false;
           if(this.displayHigherAllowanceWarningMsg){
            this.analyticsService.errorAnalyticsTrack({formErrorMessage: this.contentData.string_HigherAllowanceWarningMessageWording, formErrorType: 'Validation Errors', formErrorDetail: '0', formErrorCount: 1 })
           }
        }
        break;
      default:
        break;
    }
  }

  screenDataBinding() {   
    if (this.yourLumpSumAllowances) {
      this.displayHigherAllowanceWarningMsg = (this.yourLumpSumAllowances.lsaLgaProtectionQuestion === 'N' && this.responseApplicationData['businessType'] == 'IVPP')  ? true : false;
      this.displayProtectionTypeWarningMsg = this.yourLumpSumAllowances.protectionType ? true : false;this.yourLumpSumAllowanceForm = this.fb.group({
        lsaQuestion: [this.yourLumpSumAllowances.lsaQuestion, Validators.required],
        lsDbaQuestion: [this.yourLumpSumAllowances.lsDbaQuestion, Validators.required],
        lsaLgaProtectionQuestion: [this.yourLumpSumAllowances.lsaLgaProtectionQuestion],
        protectionType: [this.yourLumpSumAllowances.protectionType]
      });
      if (this.yourLumpSumAllowanceForm.controls['lsaQuestion'].value === 'Y' || this.yourLumpSumAllowanceForm.controls['lsDbaQuestion'].value === 'Y') {
        this.yourLumpSumAllowanceForm.controls['lsaLgaProtectionQuestion'].setValidators([Validators.required]);
      }
      if (this.yourLumpSumAllowanceForm.controls['lsaLgaProtectionQuestion'].value === 'Y') {
        this.yourLumpSumAllowanceForm.controls['protectionType'].setValidators([Validators.required]);
      }

    } else {
      this.setYourLumpSumAllownaces();
    }
    this.userFormData();
    // tslint:disable-next-line:max-line-length
    this.subscripSaveProgress =  this.applicationDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    // tslint:disable-next-line:max-line-length
    this.subscripLogout = this.applicationDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });
    const obj = new ParentFormAndElmModel(this.yourLumpSumAllowanceForm, this.el, null, null);
    this.utilService.setParentFormToValidate(obj);
  }
}
